import { useState } from 'react';
import { Header } from '../../components/feature/Header';
import { Footer } from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import WhyHongKongSection from './components/WhyHongKongSection';
import SchemesSection from './components/SchemesSection';
import WhyChooseUsSection from './components/WhyChooseUsSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import SEOStructuredData from '../../components/feature/SEOStructuredData';

export default function HKImmigrationPage() {
  return (
    <>
      <SEOStructuredData type="FAQPage" />
      <div className="min-h-screen bg-white">
        <Header />
        <HeroSection />
        <WhyHongKongSection />
        <SchemesSection />
        <WhyChooseUsSection />
        <FAQSection />
        <CTASection />
        <Footer />
      </div>
    </>
  );
}